@file:Suppress("unused")

package net.sergeych.crypto2

import net.sergeych.bintools.toDump
import net.sergeych.mp_tools.encodeToBase64Url

fun UByteArray.toDump(wide: Boolean = false) = toByteArray().toDump(wide)

fun UByteArray.encodeToBase64Url(): String = toByteArray().encodeToBase64Url()